var _defs, _rect, _text, _text2, _text3, _text4, _rect2, _text5, _text6, _line, _rect3, _text7, _text8, _rect4, _text9, _text10, _line2, _rect5, _text11, _text12, _rect6, _text13, _text14, _line3, _rect7, _text15, _text16, _rect8, _text17, _text18, _line4, _rect9, _text19, _text20, _rect10, _text21, _text22, _line5, _rect11, _text23, _text24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase7Fig3IncidentToRule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 612",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 612,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Five incidents, five standing rules")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Each measured failure produced one line of standing policy for every later operation")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 106,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "INCIDENT, MEASURED COST")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 602,
    y: 106,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "STANDING RULE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 118,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 150,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 18,
    fontWeight: 700,
    fill: "#DC2626"
  }, "21 minutes")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 176,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "one agent stalled with no output and no timeout")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 159,
    x2: 594,
    y2: 159,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 118,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 148,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RULE 01")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 174,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Slim and shard the fan-in barrier, time out per agent.")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 214,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 246,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 18,
    fontWeight: 700,
    fill: "#DC2626"
  }, "14 milliseconds")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 272,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "the run returned instantly with zero agents spawned")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 255,
    x2: 594,
    y2: 255,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 214,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 244,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RULE 02")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 270,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Verify the first run actually spawned agents.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 310,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 342,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 18,
    fontWeight: 700,
    fill: "#DC2626"
  }, "96,804 tokens")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 368,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "2 of 4 spawns duplicated the same work")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 351,
    x2: 594,
    y2: 351,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 310,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 340,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RULE 03")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 366,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Count completions against spawn receipts.")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 406,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 438,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 18,
    fontWeight: 700,
    fill: "#DC2626"
  }, "2.1x cost")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 464,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "child agents inherited effort from the parent")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 447,
    x2: 594,
    y2: 447,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 406,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 436,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RULE 04")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 462,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Pin effort explicitly per role.")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 502,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 534,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 18,
    fontWeight: 700,
    fill: "#DC2626"
  }, "11 of 24 agents")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 560,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "killed by a session limit, zero completed work lost")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 526,
    y1: 543,
    x2: 594,
    y2: 543,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 502,
    width: 470,
    height: 82,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 532,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RULE 05")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 558,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Journal and replay, delete partial files on restart.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase7Fig3IncidentToRule);
export default __webpack_public_path__ + "static/media/case7-fig3-incident-to-rule.568931ed33635dbe093e76ea36122d0b.svg";
export { ForwardRef as ReactComponent };